module.exports = __webpack_public_path__ + "media/images/app/occasions/header-mobile-ff96738e9afc3e256e8dcc997277024b.webp";